<template>
  <div id="app">
    <div>
      <v-layout justify-center row wrap>
        <v-flex xs12>
          <v-layout justify-center align-center wrap>
            <v-flex xs2 v-if="checkinitem.stockOrderItem.type === 'Active'">
              <h3 class="grey--text">
                Item:<span class="font-weight-light">
                  {{
                    checkinitem.stockOrderItem.deviceMakeModel.deviceMake.name
                  }}
                  {{ checkinitem.stockOrderItem.deviceMakeModel.name }}</span
                >
              </h3>
            </v-flex>
            <v-flex xs2>
              <h3 class="grey--text">
                Order Quantity:
                <span class="font-weight-light">
                  {{ checkinitem.stockOrderItem.quantity }}</span
                >
              </h3>
            </v-flex>
            <v-flex xs2>
              <h3 class="grey--text">
                Uploaded Quantity:
                <span class="font-weight-light"> {{ items.length }}</span>
              </h3>
            </v-flex>
            <v-flex xs2>
              <h3 class="grey--text">
                Checked-In Quantity:
                <span
                  v-if="
                    typeof checkinitem.scannedItems !== 'undefined' &&
                    checkinitem.scannedItems.length < items.length
                  "
                  class="font-weight-light red--text"
                >
                  {{ checkinitem.scannedItems.length }}</span
                >
                <span
                  class="font-weight-light green--text"
                  v-else-if="
                    typeof checkinitem.scannedItems !== 'undefined' &&
                    checkinitem.scannedItems.length >= items.length
                  "
                >
                  {{ checkinitem.scannedItems.length }}</span
                >
                <span v-else class="font-weight-light">0</span>
              </h3>
            </v-flex>
            <v-flex xs2>
              <v-btn   v-if="typeof checkinitem.scannedItems !== 'undefined'&&checkinitem.scannedItems.length>0" round color="primary" small>
                <download-csv                
                  :data="checkinitem.scannedItems"
                  name="checkinReceived.csv"
                >
                  Export Received Items
                </download-csv>
              </v-btn>
              <v-btn  v-if="notReceived.length>0" round color="primary" small>
                <download-csv :data="notReceived.map((x)=>({ponMac: x}))" name="checkinUnreceived.csv">
                  Export Non-received Items
                </download-csv>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs5 ma-1>
          <v-card>
            <v-toolbar color="primary" flat>
              <h3 class="headline white--text">CSV Upload</h3>
            </v-toolbar>
            <v-card-text>
              <div class="panel-body">
                <div class="form-group">
                  <!-- <label for="csv_file" class="control-label col-sm-3 text-right">CSV file to import</label> -->
                  <div class="col-sm-9">
                    <input
                      type="file"
                      id="csv_file"
                      name="csv_file"
                      class="form-control"
                      @change="loadCSV($event)"
                    />
                  </div>
                </div>
                <!-- <v-data-table
                  v-if="items.length > 0"
                  :headers="headers"
                  :items="items"
                  hide-actions
                >
                  <template v-slot:items="props">
                    <td
                      class="text-xs-center"
                      v-for="column in headers"
                      :key="column"
                    >
                      <span
                        v-if="
                          typeof checkinitem.scannedItems !== 'undefined' &&
                          checkinitem.scannedItems
                            .map((x) => x.ponMac)
                            .includes(props.item[column.text])
                        "
                        class="green--text"
                        >{{ props.item[column.text] }}</span
                      >
                      <span class="red--text" v-else>{{
                        props.item[column.text]
                      }}</span>
                    </td>
                  </template>
                </v-data-table> -->
                <v-data-table
                  v-if="items.length > 0"
                  :headers="headersArr"
                  :items="items"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center"
                    >
                      {{props.item.ponMac}}
                    </td>
                  </template>
                </v-data-table>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs5 ma-1>
          <v-card>
            <v-toolbar color="primary" flat>
              <h3 class="headline white--text">Scanned Items</h3>
            </v-toolbar>
            <v-toolbar flat color="white">
              <v-layout align-center row>
                <v-flex>
                  <v-text-field
                    v-model="scanItem"
                    :key="scanItemKey"
                    label="Scan Item"
                    clearable
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-btn
                    v-if="
                      typeof checkinitem.scannedItems !== 'undefined' &&
                      !checkinitem.scannedItems
                        .map((x) => x.ponMac)
                        .includes(scanItem)
                    "
                    flat
                    @click="addScanItem(scanItem)"
                    ><v-icon color="primary">add_circle_outline</v-icon></v-btn
                  >
                  <span v-else class="grey--text">Already Scanned</span>
                </v-flex>
                <v-flex mt-3>
                  <v-switch label="Auto Add" v-model="autoAdd"></v-switch>
                </v-flex>
              </v-layout>
            </v-toolbar>
            <v-layout justify-center align-center wrap>
              <v-flex
                xs12
                ma-1
                v-for="scan in checkinitem.scannedItems"
                :key="scan.ponMac"
              >
                <v-layout justify-center row wrap>
                  <v-flex xs6>
                    <h3 class="grey--text font-weight-light">
                      {{ scan.ponMac }}
                    </h3>
                  </v-flex>
                  <v-flex xs3>
                    <v-icon color="red" @click="removeScanItem(scan)"
                      >delete</v-icon
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
import Api from "@/services/Api";
export default {
  props: ["headers", "checkinitem"],
  data() {
    return {
      channel_name: "",
      channel_fields: [],
      channel_entries: [],
      parse_header: [],
      parse_csv: [],
      sortOrders: {},
      sortKey: "",
      items: [],
      matchedHeaders: [],
      scannedItems: [],
      scanItem: "",
      notReceived: [],
      autoAdd: false,
      scanItemKey: 0,
      headersArr: [
      {
        text: "Pon Mac",
        align: "center",
        value: "ponMac"
      },
      ]
    };
  },
  filters: {
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
  watch: {
    scanItem(value) {
     if (this.autoAdd == true && value != "" && value != null) {
         this.scanItem=value
        setTimeout(()=>{
        if (
          typeof this.checkinitem.scannedItems !== "undefined" && this.scanItem!=""&&
          !this.checkinitem.scannedItems.map((x) => x.ponMac).includes(this.scanItem)
        ) {
         let foundItem = this.notReceived.find(x=>x==this.scanItem)
      let index = this.notReceived.indexOf(foundItem); 
        if(index!=-1){
          this.notReceived.splice(index, 1)
        }
     let foundItemItems = this.items.find(x=>x==this.scanItem)
      let indexItems = this.items.indexOf(foundItemItems);
 
        if(indexItems!=-1){
          this.items.splice(indexItems, 1);
        }
          this.checkinitem.scannedItems.unshift({ ponMac: this.scanItem });
          this.scanItem = "";
        }        
        }, 1000);
      }         
    },
    "checkinitem.scannedItems": {
      immediate: true,
      handler(value) {
        if (value.length > 0) {
          this.$emit("scannedItemsChange", this.checkinitem.scannedItems);
        }
      },
    },
  },
  created() {
    console.log(this.checkinitem);
  },
  methods: {
    async addScanItem() {
      let foundItem = this.notReceived.find(x=>x==this.scanItem)
      let index = await this.notReceived.indexOf(foundItem); 
        if(index!=-1){
          this.notReceived.splice(index, 1)
        }
     let foundItemItems = this.items.find(x=>x==this.scanItem)
      let indexItems = await this.items.indexOf(foundItemItems);
 
        if(indexItems!=-1){
          this.items.splice(indexItems, 1);
        }
      this.checkinitem.scannedItems.unshift({ ponMac: this.scanItem });
      this.scanItem = "";
    },
    async removeScanItem(item) {
      if (typeof item.id !== "undefined") {
        Api().put("/checkinItem/" + item.id, {
          isActive: false,
          isDeleted: true,
        });
      }
      let index = this.checkinitem.scannedItems.indexOf(item);
      this.checkinitem.scannedItems.splice(index, 1);
    },
    sortBy: function (key) {
      var vm = this;
      vm.sortKey = key;
      vm.sortOrders[key] = vm.sortOrders[key] * -1;
    },
    csvJSON(csv) {
      var vm = this;
      var lines = csv.split("\n");

      var result = [];
      //var headers = lines[0].split(";"); 
      // vm.parse_header = lines[0].split(";");
      console.log(lines)
      result = lines.map(x=>({ponMac: x.replace('\r','')}))
      // lines[0].split(";").forEach(function (key) {
      //   vm.sortOrders[key] = 1;
      // });
      this.checkinitem.scannedItems = result
      // this.checkinitem.scannedItems.unshift({ ponMac: this.scanItem })
      // lines.map(function (line, indexLine) {
      //   if (indexLine < 1) return; // Jump header line
      // //  console.log(line)
      //   var obj = {};
      //   var currentline = line.split(";");
      //   // headers.map(function (header, indexHeader) {
      //   //   console.log(header, indexHeader)
      //   //   obj[header] = currentline[indexHeader];
      //   // });
      //   console.log('cur',currentline )
      //   if(currentline[0]!=''){
      //   result.push(parseInt(currentline[0].replace('/r','')));
      //   }
      // });

      //result.pop(); // remove the last item because undefined values
 
      this.items = result;
      this.notReceived = result
      return result; // JavaScript object
    },

    loadCSV(e) {
      var vm = this;
      if (window.FileReader) {
        var reader = new FileReader();
        reader.readAsText(e.target.files[0]);
        // Handle errors load
        reader.onload = function (event) {
          var csv = event.target.result;
          vm.parse_csv = vm.csvJSON(csv);
        };
        reader.onerror = function (evt) {
          if (evt.target.error.name == "NotReadableError") {
            alert("Cannot read file !");
          }
        };
      } else {
        alert("FileReader are not supported in this browser.");
      }
    },
  },
};
</script>
<style scoped>
html,
body {
  margin: 0;
  padding: 0;
}
body {
  margin: 32px auto;
}
.panel {
  border: 2px solid #dfdfdf;
  box-shadow: rgba(0, 0, 0, 0.15) 0 1px 0 0;
  margin: 10px;
}
.panel.panel-sm {
  max-width: 700px;
  margin: 10px auto;
}
.panel-heading {
  border-bottom: 2px solid #dfdfdf;
}
.panel-heading h1,
.panel-heading h2,
.panel-heading h3,
.panel-heading h4,
.panel-heading h5,
.panel-heading h6 {
  margin: 0;
  padding: 0;
}
.panel-body .checkbox-inline {
  padding: 15px 20px;
}
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
</style>